export default {"src":"/_next/static/media/ftm.ed5bb5ec.svg","height":46,"width":96,"blurWidth":0,"blurHeight":0};